
import classes from './styles.module.scss';
import { Alert, Box, Grid, TextField, TextFieldProps, Checkbox, FormControlLabel } from "@mui/material";
import { useEffect, useMemo, useState, useContext } from "react";
import { ParseDate } from '../../core/utility';
import Input from "../../components/inputs/text-field-input";
import { get, post } from '../../core/client';
import { CustomButton, CustomIconButton } from "../../components/buttons";
import Panel from "../../components/panel-card";
import DatePicker from "../../components/inputs/date-picker";
import Select, { SelectNoGuidance } from "../../components/inputs/select";
import MyTimePicker from "../../components/inputs/time-picker";
import { useLocation } from 'react-router-dom';
import { GetSplitPhoneNumber, IsNullOrEmpty, IsOnlyLetters, IsSelectEmpty, IsValidEmail, IsValidTckn } from '../../core/utility';
import { SELECT_EMPTY } from '../../core/consts';
import { AvisVehicleType } from '../../components/inputs/Models';
import { ResponseWithSuccess } from '../../core/client/Models';
import PhoneInput from '../../components/inputs/phone';
import { DisabledByDefault, QuestionAnswer, CheckCircleOutlineRounded } from '@mui/icons-material';
import AvisFormLegalModal from '../shared/AvisFormLegalModal';
import AvisFormContextProvider, { AvisFormContext, LegalContractType } from '../shared/AvisFormContext';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import { format } from 'path';

interface AvisInfo {
    marriagePrivilegeId: any,
    swUsed: string,
    phone: string

};
interface StateModel {
    driverFullName: string,
    tcIdentityNo: string,
    driverWorkMail: string,
    otherDriverExists: boolean,
    otherDriver: string,
    startOffice: string,
    startDate: any,
    startTime: any,
    endOffice: string,
    endDate: any,
    endTime: any,
    vehicleType: string,
    phone: string,
    marriageDate: any,
    //groupCDayExtendedEnabled: boolean,
}

interface InputErrorModel {
    name: string;
    errorText: string;
}
const avisInfoState: AvisInfo =
{
    marriagePrivilegeId: '',
    swUsed: '',
    phone: ''

}
const initialState: StateModel = {
    driverFullName: '',
    tcIdentityNo: '',
    driverWorkMail: '',
    otherDriverExists: false,
    otherDriver: '',
    startOffice: SELECT_EMPTY,
    startDate: '',
    startTime: '',
    endOffice: SELECT_EMPTY,
    endDate: '',
    endTime: '',
    vehicleType: SELECT_EMPTY,
    phone: '',
    marriageDate: '',
    //groupCDayExtendedEnabled: false,
};

interface CustomAvisTime {
    id: string;
    time: any;
}

const types: AvisVehicleType[] = [{ id: "groupO", name: "O Grubu - 2 Gün", vehicles: "FORD FOCUS - TOYOTA COROLLA - RENAULT MEGANE - FORD FOCUS SW - FORD FOCUS HB", onlyGroupName: "O Grubu" }, { id: "groupC", name: "C Grubu - 1 Gün", vehicles: "BMW 3 SERİSİ - VOLVO S60", onlyGroupName: "C Grubu" }, { id: "groupCExtendedDays", name: "C Grubu - 2 Gün (2.gün özel fiyat)", vehicles: "BMW 3 SERİSİ - VOLVO S60", onlyGroupName: "C Grubu" }];
var times: CustomAvisTime[] = [{ id: "00:00", time: "00:00" }, { id: "00:30", time: "00:30" }, { id: "01:00", time: "01:00" }, { id: "01:30", time: "01:30" }];
const AvisFormComponent = () => {

    const useQuery = () => {
        const { search } = useLocation();

        return useMemo(() => new URLSearchParams(search), [search]);
    };

    let query = useQuery();
    const avisGuid = query.get('rg');

    const { legalTextLoading, legalTexts, loadLegalTexts, openLegalTextModal } = useContext(AvisFormContext);

    const [state, setState] = useState<StateModel>(initialState);
    const [checkedOtherDriver, setCheckedOtherDriver] = useState(false);
    const [stateAvisInfo, setStateAvisInfo] = useState<AvisInfo>(avisInfoState);
    const [inputErrors, setInputErrors] = useState<Array<InputErrorModel>>([]);
    const [initialErrorText, setInitialErrorText] = useState('');
    const [loading, setLoading] = useState(false);
    const [avisOffices, setAvisOffices] = useState<any[]>([]);
    const [errorText, setErrorText] = useState('');
    const [actionError, setActionError] = useState('');
    const [success, SetSuccess] = useState(false);
    //const [groupCExtendedDays, setGroupCExtendedDays] = useState(false);

    useEffect(() => {
        initialLoad();

        loadLegalTexts([
            LegalContractType.KAMPANYA_KOSULLARI
        ])

    }, [avisGuid]);

    const initialLoad = async () => {
        if (avisGuid && !IsNullOrEmpty(avisGuid)) {

            const avisInfoData = await loadAvisInfo(avisGuid);
            if (avisInfoData && avisInfoData.avisInfoItem) {
                setStateAvisInfo(prev => ({
                    ...prev,
                    swUsed: avisInfoData.avisInfoItem.swUsed,
                    marriagePrivilegeId: avisInfoData.avisInfoItem.marriagePrivilegeId,

                }));
                setState(prev => ({
                    ...prev,
                    driverFullName: avisInfoData.avisInfoItem.driverFullName,
                    tcIdentityNo: avisInfoData.avisInfoItem.tckn,
                    phone: GetSplitPhoneNumber(avisInfoData.avisInfoItem.phone),
                    driverWorkMail: avisInfoData.avisInfoItem.mail,
                    marriageDate: avisInfoData.avisInfoItem.marriageDate,
                }));
            }
            loadAvisOffices();

            times = generateTimeSlots();
        }


    }

    const generateTimeSlots = (): CustomAvisTime[] => {
        const slots: CustomAvisTime[] = [];
        const startOfDay = dayjs().startOf('day');

        for (let minutes = 0; minutes < 24 * 60; minutes += 30) {
            const currentTime = startOfDay.add(minutes, 'minute');
            slots.push({
                id: currentTime.format('HH:mm'),
                time: currentTime,
            });
        }
        return slots;
    }

    const loadAvisOffices = async () => {
        const request = {};
        const { data, fail, errorMessage } = await post<any>('api/member/list-avis-offices', request);
        if (fail) {
            setErrorText(prev => errorMessage);
        }
        console.log(data);
        setAvisOffices(data.officeList);
    };
    const loadAvisInfo = async (guid: string) => {
        const { data, fail, errorMessage } = await get<any>(`api/member/get-avis-info/${guid}`);
        if (fail) {
            setInitialErrorText(prev => errorMessage);
        }
        if (data.message) {
            setInitialErrorText(prev => data.message);
        }
        return data;
    };

    const filteredAvisOffices = () => {
        if (state.vehicleType === 'groupO') {
            return avisOffices;
        } else {
            return avisOffices.filter(item => item.officeId !== 38);
        }
    }

    const handleChange = (e: any) => {

        if (e.target.type == 'checkbox') {
            setCheckedOtherDriver(e.target.checked);
        };
        if (e.target.name == 'startDate') {
            let daysToAdd = 0;
            if (state.vehicleType == 'groupC') {
                daysToAdd = 1;
            } else if (state.vehicleType == 'groupO' || state.vehicleType == 'groupCExtendedDays') {
                daysToAdd = 2;
            } else if (state.vehicleType == 'EMPTY') {
                state.startDate = '';
                state.startTime = '';
                state.endTime = '';
            }
            setState(prev => ({
                ...prev,
                ['endDate']: addDays(ParseDate(e.target.value) as Date, daysToAdd),
            }));
        };
        if (e.target.name == 'startTime') {
            setState(prev => ({
                ...prev,
                ['endTime']: e.target.value,
            }));
        };
        if (e.target.name == 'startOffice') {
            setState(prev => ({
                ...prev,
                ['startOffice']: e.target.value,
                ['endOffice']: e.target.value,
            }));
        };
        if (e.target.name == 'vehicleType') {
            let daysToAdd = 0;
            if (e.target.value == 'groupC') {
                daysToAdd = 1;
            } else if (e.target.value == 'groupO' || e.target.value == 'groupCExtendedDays') {
                daysToAdd = 2;
            }
            setState(prev => ({
                ...prev,
                [e.target.name]: e.target.value,
                ['endDate']: (state.startDate != '') ? addDays(ParseDate(state.startDate) as Date, daysToAdd) : ''
            }));
        }
        setState(prev => ({
            ...prev,
            [e.target.name]: (e.target.type == 'checkbox') ? e.target.checked : e.target.value,
        }));
    };

    const addDays = (date: Date, days: number) => {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }


    const setError = (name: keyof StateModel, errorText = 'Zorunlu alan') => {
        const error: InputErrorModel = { name, errorText };
        setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
    };

    const validate = (model: StateModel): boolean => {
        setInputErrors([]);

        let isValid = true;
        if (!IsValidTckn(model.tcIdentityNo)) {
            setError('tcIdentityNo', 'Geçersiz TC kimlik no');
            isValid = false;
        }
        if (IsNullOrEmpty(model.driverFullName,) || !IsOnlyLetters(model.driverFullName)) {
            setError('driverFullName', 'Geçersiz ad');
            isValid = false;
        }
        if (!IsNullOrEmpty(model.otherDriver)) {

            if (!IsOnlyLetters(model.otherDriver)) {
                setError('otherDriver', 'Yanlızca harf girilebilir');
                isValid = false;

            }
        }

        if (IsSelectEmpty(model.startOffice)) {
            setError('startOffice', 'Geçersiz alış ofisi');
            isValid = false;
        }
        if (IsSelectEmpty(model.endOffice)) {
            setError('endOffice', 'Geçersiz iade ofisi');
            isValid = false;
        }
        if (IsNullOrEmpty(model.startDate)) {
            setError('startDate', 'Geçersiz alış tarihi');
            isValid = false;
        }
        if (IsNullOrEmpty(model.endDate)) {
            setError('endDate', 'Geçersiz iade tarihi');
            isValid = false;
        }
        if (IsNullOrEmpty(model.startTime)) {
            setError('startTime', 'Geçersiz iade zamanı');
            isValid = false;
        }
        if (IsNullOrEmpty(model.endTime)) {
            setError('endTime', 'Geçersiz iade zamanı');
            isValid = false;
        }

        if (IsNullOrEmpty(model.vehicleType)) {
            setError('vehicleType', 'Geçersiz araç tipi');
            isValid = false;
        }
        if (!IsValidEmail(model.driverWorkMail)) {
            setError('driverWorkMail', 'Geçersiz e-posta');
            isValid = false;
        }
        if (IsNullOrEmpty(model.phone) || model.phone[0] !== '5' || model.phone.length !== 10) {
            setError('phone', 'Geçersiz telefon');
            isValid = false;
        }

        return isValid;
    };

    const handleSend = async (model: StateModel) => {
        setActionError('');
        if (!validate(model)) return;
        // setLoadingSendForm(true);

        dayjs.extend(utc);

        const request = {
            Guid: avisGuid,
            MailAddress: model.driverWorkMail,
            OtherDriver: model.otherDriverExists ? model.otherDriver : '',
            StartOffice: model.startOffice,
            EndOffice: model.endOffice,
            StartDate: model.startDate,
            EndDate: dayjs(state.endDate).format('DD.MM.YYYY'),
            StartTime: dayjs(model.startTime).utc().toISOString(),
            EndTime: model.endTime,
            VehicleType: model.vehicleType.toString(),
            DriverFullName: model.driverFullName,
            DriverPhone: model.phone,
            Tckn: model.tcIdentityNo,
        };
        const { data, fail, errorMessage } = await post<any>('api/member/complete-avis-form', request);

        if (fail) {
            setActionError(errorMessage);
        }
        if (data && data.message) {
            setActionError(prev => data.message);
        }
        if (data && data.success) {
            SetSuccess(true);
            return data;
        }

    };

    const openSSS = () => {
        const pdfUrl = `/docs/AvisSSS.pdf`;
        window.open(pdfUrl, '_blank');

    };

    const handleCampaignConditions = () => {
        openLegalTextModal(LegalContractType.KAMPANYA_KOSULLARI);
    };

    const handleRentalConditions = () => {
        const conditionLink = "https://www.avis.com.tr/arac-kiralama-kosullari";
        window.open(conditionLink, '_blank');
    };

    return (
        <div className={classes.AvisForm}>
            <div className={classes.overlay}>
                <div className={classes.container}>
                    <div className={classes.form}>
                        <Grid container marginBottom={3} sx={{}}>
                            <Grid item sm={4} xs={12}>
                                <CustomButton
                                    text="SSS"
                                    className={`${classes.themeColoring} btn-primary`}
                                    icon={<QuestionAnswer color='success' />}
                                    onClick={() => openSSS()} />
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <img className={classes.AvisLogo}></img>
                            </Grid>
                            <Grid item sm={4} xs={12}>

                            </Grid>
                        </Grid>
                        <div className={classes.text}>
                            <p><h1>KOÇAİLEM & AVIS EVLİLİK AYRICALIĞI</h1>
                                <h2>Araç Kiralama Rezervasyon Formu</h2></p>
                            {initialErrorText && (
                                <Box marginBottom={2}>
                                    <Alert severity="error">{initialErrorText}</Alert>
                                </Box>
                            )}
                            {actionError && (
                                <Box marginBottom={2}>
                                    <Alert severity="error">{actionError}</Alert>
                                </Box>
                            )}
                            {(success) ? (
                                <Grid container spacing={4}>
                                    <Grid item sm={12} xs={12}>
                                        <div className={classes.successMessage}>
                                            <CheckCircleOutlineRounded className={classes.successIcon} />
                                            <h4>{"KoçAilem & Avis Evlilik Ayrıcalığı Araç Kiralama Rezervasyon Formu Başarıyla Gönderildi"}</h4>
                                        </div>
                                    </Grid>
                                </Grid>
                            ) : (
                                <>
                                    {
                                        <Grid container marginBottom={3} columnSpacing={2} rowSpacing={3} sx={{ marginTop: 2 }}>
                                            <Grid item sm={6} xs={12}>
                                                <Input
                                                    id="driverFullName"
                                                    disabled
                                                    name="driverFullName"
                                                    caption="Çalışan Ad - Soyad"
                                                    value={state.driverFullName}
                                                    onChange={handleChange}
                                                    errorText={inputErrors.find(x => x.name === 'driverFullName')?.errorText}
                                                />
                                                <input id="driverFullName" name="driverFullName" value={state.driverFullName} hidden />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <Input
                                                    id="tcIdentityNo"
                                                    name="tcIdentityNo"
                                                    caption="Çalışan TC Kimlik No"
                                                    disabled
                                                    toUpperCase
                                                    value={state.tcIdentityNo}
                                                    onChange={handleChange}
                                                    errorText={inputErrors.find(x => x.name === 'tcIdentityNo')?.errorText}
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <PhoneInput
                                                    id="phone"
                                                    name="phone"
                                                    caption="Çalışan Cep Telefonu"
                                                    placeholder="(5##) ### ## ##"
                                                    format="(###) ### ## ##"
                                                    value={state.phone}
                                                    disabled
                                                    onChange={handleChange}
                                                    errorText={inputErrors.find(x => x.name === 'phone')?.errorText}
                                                />
                                            </Grid>
                                            <Grid item sm={6} xs={12}>
                                                <Input
                                                    id="driverWorkMail"
                                                    name="driverWorkMail"
                                                    caption="Çalışan İş Email"
                                                    disabled
                                                    toUpperCase
                                                    value={state.driverWorkMail}
                                                    onChange={handleChange}
                                                    errorText={inputErrors.find(x => x.name === 'driverWorkMail')?.errorText}
                                                />
                                            </Grid>

                                            <Grid item sm={12} xs={12}>
                                                <Select
                                                    id="vehicleType"
                                                    name="vehicleType"
                                                    caption="Araç Grubu"
                                                    //className="mb-2"
                                                    disabled={loading}
                                                    loading={loading}

                                                    onChange={handleChange}
                                                    options={{
                                                        data: types,
                                                        displayField: 'name',
                                                        displayValue: 'id',
                                                        selected: state.vehicleType
                                                    }}
                                                    errorText={inputErrors.find(x => x.name === 'vehicleType')?.errorText}
                                                />
                                            </Grid>
                                            {/*<Grid container item>
                                        <Grid item sm={3} xs={12}>
                                            <FormControlLabel
                                                control={<Checkbox
                                                    id="groupCDayExtendedEnabled"
                                                    name="groupCDayExtendedEnabled"
                                                    value={state.groupCDayExtendedEnabled}
                                                    checked={groupCExtendedDays}
                                                    onChange={handleChange}
                                                />}
                                                label="2 Gün"
                                            />
                                        </Grid>
        
                                        <Grid item sm={9} xs={12} sx={{ display: { sm: (state.groupCDayExtendedEnabled) ? 'flex' : 'none' } }}>
                                        <Alert severity="info">1 günlük ücret tarafınıza yansıtılacaktır.</Alert>
                                        </Grid>
                                                </Grid>*/}
                                            {/*<Grid item sm={6} xs={12} sx={{ display: { sm: (state.vehicleType == 'EMPTY') ? 'none' : 'flex' }, justifyContent: 'flex-end' }}>
                                                <Alert severity="info">{types.filter(vehicle => vehicle.id == state.vehicleType).at(0)?.vehicles ?? ""}</Alert>
                                            </Grid>*/}
                                            <Grid item sm={12} xs={12} sx={{ display: (state.vehicleType == 'groupCExtendedDays') ? 'flex' : 'none' }}>
                                                <Alert severity="info">1 günlük özel ücret tarafına yansıtılacaktır.</Alert>
                                            </Grid>
                                            <Grid item sm={12} xs={12} sx={{ display: (state.vehicleType == 'EMPTY') ? 'none' : 'flex' }}>
                                                <Alert severity="warning">Rezervasyonlar araç grubu bazında yapılmaktadır ve marka garantisi verilmemektedir. Örnek {types.filter(vehicle => vehicle.id == state.vehicleType).at(0)?.onlyGroupName ?? ""} grubu araçlar: {types.filter(vehicle => vehicle.id == state.vehicleType).at(0)?.vehicles ?? ""}</Alert>
                                            </Grid>
                                            {
                                                <Grid container item>
                                                    <Grid item sm={3} xs={12}>
                                                        <FormControlLabel
                                                            control={<Checkbox
                                                                id="otherDriverExists"
                                                                name="otherDriverExists"
                                                                value={state.otherDriverExists}
                                                                checked={checkedOtherDriver}
                                                                onChange={handleChange}
                                                            />}
                                                            label="Ek Sürücü"
                                                        />
                                                    </Grid>

                                                    <Grid item sm={9} xs={12} sx={{ display: (state.otherDriverExists) ? 'flex' : 'none' }}>
                                                        <Input
                                                            id="otherDriver"
                                                            name="otherDriver"
                                                            caption="Ek Sürücü Adı - Soyadı"
                                                            toUpperCase
                                                            value={state.otherDriver}
                                                            onChange={handleChange}
                                                            errorText={inputErrors.find(x => x.name === 'otherDriver')?.errorText}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            }
                                            <Grid item sm={12} xs={12} sx={{ display: (state.otherDriverExists) ? 'flex' : 'none' }}>
                                                <Alert severity="warning">Araçla ilgili tüm sorumluluk ana sürücü olarak belirlenen Koç Topluluğu çalışanına aittir.</Alert>
                                            </Grid>
                                            <Grid item sm={12} xs={12} sx={{}}>
                                                <Alert severity="info">İnsan Kaynakları’na yaptığın başvurudan sonra araç rezervasyonunu 3 ay içinde tamamlamalısın. Kiralama tarihi, başvuru tarihinden başlayıp nikah tarihinin en fazla 3 ay sonrasına kadar olabilir.  Rezervasyonların doluluk oranları göz önünde bulundurularak rezervasyonun kiralama tarihinden minimum 1 ay öncesinde yapılması gerekmedir.</Alert>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Panel title="Alış Detayları" className={classes.themeColoring}>
                                                    <Grid item container sm={12} xs={12} direction="row" rowSpacing={2} columnSpacing={2} >
                                                        <Grid item sm={12} xs={12}>
                                                            <Select
                                                                id="startOffice"
                                                                name="startOffice"
                                                                caption="Alış Ofisi"
                                                                //className="mb-2"
                                                                disabled={loading}
                                                                loading={loading}
                                                                onChange={handleChange}
                                                                options={{
                                                                    data: filteredAvisOffices(),
                                                                    displayField: 'officeName',
                                                                    displayValue: 'officeId',
                                                                    selected: state.startOffice
                                                                }}
                                                                errorText={inputErrors.find(x => x.name === 'startOffice')?.errorText}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={6} xs={12}>
                                                            <DatePicker
                                                                id="startDate"
                                                                name="startDate"
                                                                caption="Alış Tarihi"
                                                                value={state.startDate}
                                                                disabled={state.vehicleType == "EMPTY"}
                                                                onChange={handleChange}
                                                                disablePast
                                                                minDate={dayjs().add(1, 'day').toString()}
                                                                maxDate={dayjs(state.marriageDate, 'DD.MM.YYYY').add(3, 'month').toString()}
                                                                errorText={inputErrors.find(x => x.name === 'startDate')?.errorText}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={6} xs={12}>
                                                            <SelectNoGuidance
                                                                id="startTime"
                                                                name="startTime"
                                                                caption="Alış Saati"
                                                                disabled={state.vehicleType == "EMPTY"}
                                                                loading={loading}
                                                                onChange={handleChange}
                                                                options={{
                                                                    data: times,
                                                                    displayField: 'id',
                                                                    displayValue: 'time',
                                                                    selected: state.startTime
                                                                }}
                                                                errorText={inputErrors.find(x => x.name === 'startTime')?.errorText}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Panel>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Panel title="İade Detayları" className={classes.themeColoring}>
                                                    <Grid item container sm={12} xs={12} direction="row" rowSpacing={2} columnSpacing={2} >
                                                        <Grid item sm={12} xs={12}>
                                                            <Select
                                                                id="endOffice"
                                                                name="endOffice"
                                                                caption="İade Ofisi"
                                                                //className="mb-2"
                                                                disabled={loading}
                                                                loading={loading}
                                                                onChange={handleChange}
                                                                options={{
                                                                    data: filteredAvisOffices(),
                                                                    displayField: 'officeName',
                                                                    displayValue: 'officeId',
                                                                    selected: state.endOffice
                                                                }}
                                                                errorText={inputErrors.find(x => x.name === 'endOffice')?.errorText}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={6} xs={12}>

                                                            <DatePicker
                                                                id="endDate"
                                                                name="endDate"
                                                                caption="İade Tarihi"
                                                                disabled
                                                                value={state.endDate}
                                                                onChange={handleChange}
                                                                disablePast
                                                                minDate={dayjs().add(1, 'day').toString()}
                                                                errorText={inputErrors.find(x => x.name === 'endDate')?.errorText}
                                                            />
                                                        </Grid>

                                                        <Grid item sm={6} xs={12}>

                                                            <SelectNoGuidance
                                                                id="endTime"
                                                                name="endTime"
                                                                caption="İade Saati"
                                                                disabled
                                                                loading={loading}
                                                                onChange={handleChange}
                                                                options={{
                                                                    data: times,
                                                                    displayField: 'id',
                                                                    displayValue: 'time',
                                                                    selected: state.endTime
                                                                }}
                                                                errorText={inputErrors.find(x => x.name === 'endTime')?.errorText}
                                                            />
                                                        </Grid>
                                                        <Grid item sm={12} xs={12} sx={{}}>
                                                            <Alert severity="info">Seçilen araç grubuna göre iade tarihi otomatik olarak belirlenmektedir.</Alert>
                                                        </Grid>
                                                        <Grid item sm={12} xs={12} sx={{ display: (state.startOffice != state.endOffice) ? 'flex' : 'none' }}>
                                                            <Alert severity="warning">Farklı ofise iade durumunda ek ücretler çıkabilir. Detaylı bilgi AVIS rezervasyon merkezince sağlanacaktır.</Alert>
                                                        </Grid>
                                                    </Grid>
                                                </Panel>
                                            </Grid>

                                            <Grid item sm={12} xs={12}>
                                                <Box display="flex" justifyContent="center">
                                                    <CustomButton
                                                        text="FORMU GÖNDER"
                                                        className={`${classes.themeColoring} btn-primary`}
                                                        disabled={loading || initialErrorText.length > 0 || success}
                                                        loading={loading}
                                                        onClick={() => handleSend(state)}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item sm={12} xs={12} marginTop={1}>
                                                <p><button style={{ textDecoration: "underline" }} onClick={handleCampaignConditions}>Kampanya Koşulları</button> için tıklayınız.</p>
                                                <p><button style={{ textDecoration: "underline" }} onClick={handleRentalConditions}>AVIS Genel Kiralama Koşulları</button> için tıklayınız.</p>
                                            </Grid>
                                        </Grid>
                                    }
                                </>
                            )}
                        </div>


                    </div>

                </div>
            </div>
        </div>
    );
};

const AvisForm = () => (
    <AvisFormContextProvider>
        <AvisFormComponent />
    </AvisFormContextProvider>
);

export default AvisForm;


